import {FC, useEffect} from 'react';
import {useNavigate} from "react-router-dom";

// This is a placeholder page for admin to make it possible to navigate to /admin without specifying a subpage.
// It will automatically redirect to /admin/registrations, which is the default admin page.
const Admin: FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/admin/registrations');
  }, [navigate]);
  
  return <></>;
};

export default Admin;
